<template>
  <div class="home net-status-home">
    <Layout
      layoutType="HARDLIST"
      isRevenue="true"
      pageTitle="轻节点"
    >
      <BasiceLayout title="故障设备查询">
        <div class="hardware-content">        
          <div class="margin-20 display-flex">
            <el-input
              v-model="searchmac"
              placeholder="输入要搜索的Mac地址"
              style="max-width: 200px"
            ></el-input>
            <div
              class="button"
              @click="search"
            >搜索</div>
          </div>
          <div v-loading="isLoading">
            <el-table
              v-if="deverrList && deverrList != null"
              :data="deverrList.slice((currentPage-1)*deviceNumSize, currentPage*deviceNumSize)"
              align="left"
              empty-text="无"
              style="width: 100%"
            >
              <el-table-column
                prop="muhua_mac"
                label="mac"
                align='center'
              >
              </el-table-column>
              <el-table-column
                prop="env_err"
                label="故障内容"
                align='center'
              >
              </el-table-column>
              <el-table-column
                prop="suggestion"
                label="建议"
                align='center'
              >
              </el-table-column>
            </el-table>
            <div class="pagination" v-if="deviceLength > 1">
              <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
                :page-size="deviceNumSize" layout="total, prev, pager, next" :total="deviceLength">
              </el-pagination>
            </div>
          </div>
        </div>
      </BasiceLayout>
    </Layout>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import moment from "moment";
import { Message } from "element-ui";
import { LANG } from "../../../config/contant.js";
import Layout from "@/components/DatePanel/Layout.vue";
import { BytesToM, toFixed } from "@/utils/utils";

export default {
  name: "home",
  components: {
    BasiceLayout,
    Layout
  },
  data() {
    return {
      searchmac:"",
      deverrList:[],
      currentPage: 1,
      deviceNumSize: 10,
      deviceLength: 0,
      isLoading: false
    };
  },
  computed: mapState({
    nodeConfig: state => state.standardNode.nodeConfig,
  }),
  methods: {
    ...mapActions([
      "getStandardNode",
      "getDevErr",
      "getDevErrBymac",
    ]),

    //获取故障设备数据
    getDevErrData(){
      this.isLoading = true;
      this.getDevErr({ type:"lite", from_type:1 }).then(res => {
        console.log('获取轻节点故障设备：',res)
        this.isLoading = false;
        if(res.code == 200){
          this.deverrList = res.dev_err_list ? res.dev_err_list : [];
          this.deviceLength = res.dev_err_list.length ? res.dev_err_list.length : 0;
        } else {
          Message.error(res.err_msg || res.message);
          this.deverrList = [];
        }
      }).catch(err=>{
        return Message.error(err);
      })
    },
    search() {
      if(!this.searchmac){
        this.getDevErrData();
      }else{
        this.isLoading = true;
        let searchmac = this.searchmac;
        const params = {
          type: 'lite',
          macAddr: searchmac
        }
        this.getDevErrBymac(params).then(res => {
          this.isLoading = false;
          if(res.code == 200 && !res.dev_err_list.length == 0){
              this.deverrList = res.dev_err_list;
              Message({
                type:'success',
                message:'搜索成功'
              })
            }else if(res.code == 200 && res.dev_err_list.length == 0 ){
              Message({
                type:'error',
                message:'搜索数据为空'
              })
            }else{
              Message({
                type:'error',
                message:res.err_msg || res.message,
              })
            }
          })
       }
     },
     handleCurrentChange(val) {
       this.currentPage = val
     }
   },

  created() {
    this.getDevErrData();
  }
};
</script>

<style lang="stylus">


</style>
